// Copyright (c) 2020 Deere & Company

const defaultLoadingState = 0;

export const showLoadingIndicator = applicationState => applicationState > defaultLoadingState;
